// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___PuNeu","open":"open___2P6CM","label":"label___El5v2","labelRow":"labelRow___13GIA","labelText":"labelText___xWqgH","required":"required___o2Iku"};